module.exports = __webpack_public_path__ + "img/forgot-password.f1d8d23e.png";